import { Link } from "react-router-dom";

const Item = ({ id, name, img, price, stock }) => {
  return (
    <article className="flex flex-col justify-between bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300 w-full sm:w-64 md:w-72 lg:w-80 mx-auto">
      
      {/* Imagen del producto */}
      <picture className="flex justify-center items-center bg-gray-50 p-4">
        <img
          src={img}
          alt={name}
          className="w-40 h-40 object-contain"
        />
      </picture>

      {/* Detalles */}
      <div className="flex flex-col flex-grow px-5 py-4 text-center">
        <h2 className="text-lg font-semibold text-gray-800 mb-2 truncate">{name}</h2>
        <p className="text-gray-600 text-sm mb-1">Precio: <span className="font-medium text-gray-900">${price}</span></p>
        <p className="text-gray-600 text-sm mb-3">Stock disponible: <span className="font-medium">{stock}</span></p>

        {/* Botón Ver Detalle */}
        <div className="mt-auto">
          <Link
            to={`/item/${id}`}
            className="inline-block w-full sm:w-auto px-4 py-2 text-sm font-semibold text-purple-600 border border-purple-300 rounded-full hover:bg-purple-600 hover:text-white hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2 transition"
          >
            Ver Detalle
          </Link>
        </div>
      </div>
    </article>
  );
};

export default Item;
